/**
 * Consent Insert V1 Service
 * Migrated from 3in1cms legacy/consentInsertV1.ts
 */

import { request } from "../core/request";
import { API_RESPONSE_CODES, OPERATION_IDS, WEB_SOURCE_IDENTIFIER } from "./constants";
import type {
  IConsentInsertRequestV1,
  IConsentInsertResponse,
} from "../types/consentInsertV1Types";

/**
 * Insert consent for user
 * @param partnerName - Partner name
 * @param consentCategory - Category of consent
 * @param consentValueStatus - Consent status boolean
 * @param mobileNo - User mobile number
 * @param custId - Customer ID
 * @param firstName - First name
 * @param lastName - Last name
 * @returns Consent insert response
 */
export const consentInsert = async (
  partnerName: string,
  consentCategory: string,
  consentValueStatus: boolean,
  mobileNo: string,
  custId?: string,
  firstName?: string,
  lastName?: string
): Promise<IConsentInsertResponse> => {
  try {
    const consentStatus = consentValueStatus ? "Y" : "N";

    const requestPayload: IConsentInsertRequestV1 = {
      mobileNo,
      deviceId: "1234",
      sourcingChannel: WEB_SOURCE_IDENTIFIER,
      partnerName: partnerName ?? "",
      consentCategory: consentCategory ?? "",
      consentStatus,
      consentData: {
        customerId: custId ?? "1234567",
        firstName: firstName || "NA",
        lastName: lastName || "NA",
        mobile: mobileNo,
      },
    };

    const consentResponse = (await request<IConsentInsertResponse, IConsentInsertRequestV1>({
      operationId: OPERATION_IDS.consentInsert,
      requestData: requestPayload,
      additionalHeaders: {
        apiVersion: "v1",
      },
    })) as IConsentInsertResponse;

    if (consentResponse.statusCode === API_RESPONSE_CODES.STATUS_CODE_7001) {
      return consentResponse;
    }

    throw new Error(JSON.stringify(consentResponse));
  } catch (err) {
    console.error("Error in consentInsert", err);
    throw err;
  }
};
